export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q05_b.bd7f524f.png";